import React, { ReactNode } from "react";


export class ReactUtils {

  /**
   * Converte o nó react em texto
   * 
   * Baseado em: https://github.com/facebook/react/issues/9255#issuecomment-452368065
   */
  static asText(children?: ReactNode) {
    let label = '';

    React.Children.map(children, (child) => {
        if (typeof child === 'string') {
            label += child;
        }
    });

    return label;
  };
}